import * as React from "react";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { ActiveCell, SignatureCell, EditCommandCell } from "../GridComponents";

const SuppliersList = ({ loading, supplierCategories, enterEdit }) => {
  const MyEditCommandCell = (props) => (
    <EditCommandCell {...props} enterEdit={enterEdit} />
  );

  return (
    <div className="settings-grid">
      <Grid
        data={supplierCategories}
        loading={loading}
        style={{ minHeight: "400px" }}
      >
        <Column
          title=" "
          width="80"
          field="categoryName"
          cell={(props) => <SignatureCell {...props} />}
        />
        <Column field="categoryName" title="Category Name" />
        <Column field="active" title="Active" width="80" cell={ActiveCell} />
        <Column title="Edit" width="80" cell={MyEditCommandCell} />
      </Grid>
    </div>
  );
};

export default SuppliersList;
